import { render } from "./GlobalAurionCapsuleDialog.vue?vue&type=template&id=0344ee0a"
import script from "./GlobalAurionCapsuleDialog.vue?vue&type=script&lang=js"
export * from "./GlobalAurionCapsuleDialog.vue?vue&type=script&lang=js"

import exportComponent from "/home/vsts/work/1/s/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__